import React from 'react';
import { useWorkshopMode } from '../../stores/WorkshopModeContext';

const HideInWorkshop = ({ children }) => {
  const { workshopMode } = useWorkshopMode();
  return workshopMode ? null : children;
};

export default HideInWorkshop;
